import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Отправить запрос на получение контентой части постов
export const getUserBriefcase = async () => {
  const url = `${backendUrl}/api/widgets/market-pulse/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении портфеля: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка получения портфеля:', error);
    throw error;
  }
};